export const REQUEST_SPONSOR_LIST = "REQUEST_SPONSOR_LIST"
export const REQUEST_SPONSOR = "REQUEST_SPONSOR"